export default "__VITE_ASSET__D6SpS21N__"